import React, { Component } from 'react';
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import FilterHeader from './filterHeader'

class Filter extends Component {
    state = {
        search_value: ""
    }

    onFilterChange = (e) => {
        this.setState({ search_value: e.target.value });
    };

    getPlaceHolderText = (name) => {
        const starts_with_vowel = (/^[aeiou]/i).test(name);
        return "Find " + (starts_with_vowel ? 'an ' : 'a ') + name.toLowerCase();
    };

    render() {
        // 2. instances.slice(0, 5) needs to be smarter and display instances that are checked
        const { name: name_raw, instances, type, label, selected_instances } = this.props;
        const name = name_raw === 'companies' ? 'company' : name_raw;
        const { search_value } = this.state;
        const search_value_lower_case = search_value.toLowerCase();
        const displayed_instances = search_value ? 
                                        instances.map(instance => {
                                            instance.value = instance[label].toLowerCase();
                                            return instance;
                                        }).filter(
                                            instance => instance.value.includes(search_value_lower_case)
                                        ) :
                                        instances;
        const selected_filters = selected_instances[type] || [];
        return (
            <Card className="bg-white filter-card">
              <FilterHeader 
                eventKey={ name }
                name={ name }>
              </FilterHeader>
              <Accordion.Collapse eventKey={ name }>
                <Card.Body className="py-2">
                  <input 
                      className="my-2 p-2 rounded-corners filter-card-input"
                      type="text" 
                      value={this.props.search_value} 
                      onChange={this.onFilterChange}
                      placeholder={ this.getPlaceHolderText(name) } />
                  { displayed_instances.length && 
                      displayed_instances.filter(
                        instance => instance[label] !== "Went To Spam"
                      ).map(instance => 
                      <div 
                          key={ instance.id }
                          className="filter-card-category my-1">
                          <input 
                              name={ instance.id }
                              id={ "child-category-" + instance.id }
                              type="checkbox" 
                              checked={ selected_filters.length ? 
                                          selected_filters.includes(instance.id.toString()) :
                                          false } 
                              onChange={ e => this.props.onFilterSelect(type, e) }/>
                          <label 
                              className="form-check-label pl-3 text-primary filter-card-category-label"
                              htmlFor={ "child-category-" + instance.id }> 
                              { instance[label] } 
                          </label>
                      </div>) }
                  { !displayed_instances.length && <p>No filters found!</p>}                    
                </Card.Body>
              </Accordion.Collapse>
            </Card>
        );
    }
}

export default Filter;